export default __webpack_public_path__ + "static/media/dpk_resume.6d2eb122.pdf";